import { Injectable } from '@angular/core';
import { NotificationJob, NotificationJobPagedRequest, PagedResponse } from './model';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  constructor(private http: HttpClient) { }

  list(req: NotificationJobPagedRequest): Observable<PagedResponse<NotificationJob>> {
    return this.http.post<PagedResponse<NotificationJob>>(
      `${environment.apiUrl}/Admin/GetPendingNotificationsJobs`, req);
  }

  generateAutoRenewalNotifications(daysAhead: number): Observable<void> {
    return this.http.get<void>(
      `${environment.apiUrl}/Admin/GenerateAutoRenewalNotifications/${daysAhead}`);
  }

  importNotificationsFromCSV(file: FormData): Observable<void> {
    return this.http.post<void>(
      `${environment.apiUrl}/Admin/ImportNotificationsFromCSV`, file);
  }

  processPendingNotifications(): Observable<void> {
    return this.http.get<void>(
      `${environment.apiUrl}/Admin/ProcessPendingNotifications`);
  }

  exportNotifications(req: NotificationJobPagedRequest): Observable<Blob> {
    return this.http.post<Blob>(
      `${environment.apiUrl}/Admin/ExportNotifications`, req, { responseType: 'blob' } as any) as any;
  }

  updateNotification(notification: NotificationJob) {
    return this.http.post<void>(
      `${environment.apiUrl}/Admin/UpdateNotification`, notification);
  }

  deleteNotification(notification: NotificationJob) {
    return this.http.get<void>(
      `${environment.apiUrl}/Admin/DeleteNotification/${notification.id}`);
  }

}
